import { Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  id: number | null;
};

const IDCell = React.memo((row: KpiWorkunitGridData) => (
  <>
    <Typography variant="body2" noWrap>
      {row.id}
    </Typography>
  </>
));

export default IDCell;
